<template>
    <div>
        <menu-bar v-if="menu"/>
        <div class="container" role="main">
            <div class="row" style="margin-top: 50px">

                <ol class="breadcrumb">
                    <li><a :href="'#/'"><i class="fa fa-home" aria-hidden="true"></i> INICIAL</a></li>
                    <li><a :href="'#/caixas-switch'"><i class="fa fa-suitcase" aria-hidden="true"></i> CAIXAS PAC-SWITCH</a></li>
                    <li class="active">CADASTRO DE CAIXAS PAC-SWITCH</li>
                </ol>

                <go-back v-if="menu" :url="'#/caixas-switch'"/> &nbsp;
                <button type="button" v-if="user.level < 5" :disabled="! caixa.pacpon._id"
                        @click="save()"
                        class="btn btn-success">
                    <i class="fa fa-save" aria-hidden="true"></i> SALVAR CAIXA PAC-SWITCH
                </button>
                <br v-if="menu"/>
                <br v-if="menu"/>

                <div class="panel panel-info">
                    <!-- Default panel contents -->
                    <div class="panel-heading">
                        <i class="fa fa-info-circle" aria-hidden="true"></i> DADOS BÁSICOS
                    </div>
                    <div class="panel-body">

                        <div class="row" >

                            <div class="col-sm-3">
                                <label :class="{'text-danger': !caixa.pacpon._id}" class="control-label">CAIXA PAC-PON</label>
                                <filtro-pacpon v-model="caixa.pacpon" />
                            </div>

                            <div class="col-sm-3">
                                <label class="control-label">GERENCIÁVEL</label>
                                <select class="form-control" v-model="caixa.gerenciavel">
                                    <option :value="true">SIM</option>
                                    <option :value="false">NÃO</option>
                                </select>
                            </div>

                            <div class="col-sm-3">
                                <label class="control-label">V-LAN</label>
                                <input class="form-control" v-model="caixa.vlan">
                            </div>

                            <div class="col-sm-3">
                                <label class="control-label">MAC ONU</label>
                                <input class="form-control" v-model="caixa.onu_mac">
                            </div>

                        </div>

                    </div>
                </div>

                <form class="form-horizontal" >

                    <place :place.sync="caixa.place" :height="'500px'" />

                    <div class="form-group">
                        <div class="col-sm-10">
                            <button type="button" v-if="user.level < 5" :disabled="! caixa.pacpon._id"
                                    @click="save()"
                                    class="btn btn-success">
                                <i class="fa fa-save" aria-hidden="true"></i> SALVAR CAIXA PAC-SWITCH
                            </button>
                        </div>
                    </div>

                </form>

                <br/>
                <list-clientes-no-switch v-if="caixa._id && menu" :_id="caixa._id" />

            </div>
        </div>
    </div>
</template>
<script>
import { CaixaSwitch, CaixaPacPon } from "../../../class/index";
import { Place, ListClientesNoSwitch } from "../../../components/exports";
import filtroPacpon from "../../../components/caixas/filtro-pacpon";
import GoBack from "../../../components/buttons/goback";

export default {
    components: {
        Place,
        GoBack,
        filtroPacpon,
        ListClientesNoSwitch
    },
    data() {
        return {
            menu: true,
            user: null,
            caixa: CaixaSwitch.create(),
            caixas: [],
            fibras: []
        };
    },
    computed: {
        _id() {
            return this.$route.params.id;
        }
    },
    beforeMount() {
        this.user = this.$store.state.user;
        this.loadCTOs();

        if (this.$route.query.disable_menu === "1") {
            this.menu = false;
        }

        if (this._id) {
            this.loadPonto(this.$route.params.id);
        } else if (this.$route.params.lat && this.$route.params.lng) {
            this.caixa = CaixaSwitch.create();
            this.caixa.place = [
                Number(this.$route.params.lng),
                Number(this.$route.params.lat)
            ];
            this.menu = false;
        }
    },
    beforeDestroy() {
        console.log("ponto off");
    },
    methods: {
        async loadPonto(id) {
            this.caixa = await CaixaSwitch.byID(id);
        },
        async loadCTOs() {
            this.caixas = await CaixaPacPon.all();
        },
        portaSelecionada() {
            let caixas = this.caixas.filter(caixa => {
                return caixa._id === this.caixa.pacpon._id;
            });

            if (caixas.length) {
                this.caixa.porta_pon = caixas[0].porta_pon;
                this.caixa.fibra = caixas[0].fibra;
            }

            /*
                this.caixas.forEach((caixa) => {
                    if (caixa._id) {

                    }
                });
                */
        },
        save() {
            // eslint-disable-next-line no-undef
            swal.queue([
                {
                    title: "SALVAR",
                    confirmButtonText: "Salvar",
                    text: "Posso salvar o ponto?",
                    showCancelButton: true,
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return new Promise(resolve => {
                            CaixaSwitch.save(this.caixa)
                                .then(res => {
                                    resolve();
                                    if (this.menu) {
                                        if (this.caixa._id) {
                                            return this.$router.push({
                                                path: "/caixas-switch"
                                            });
                                        }
                                        this.loadPonto(res._id);
                                    } else {
                                        window.close();
                                    }
                                })
                                .catch(err => {
                                    console.log(err);
                                    resolve();
                                });
                        });
                    }
                }
            ]);
        }
    }
};
</script>
